import { getFormValues } from 'redux-form';

import { trackToSAction } from './gaTracking';

import {
    clearAuthNotification,
    showAuthNotification,
    cleanSocialAuthenticationData,
} from './auth';

import { handleSocialLogin } from './social';

import { getQuerySourceProvider } from './utils';

import { handleAppleSocialLogin } from './appleLogin';

import { GA_APPLE, TOSMODAL_SOCIAL_ACCEPTED } from '../constants/analytics';
import { LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT } from '../constants';

/**  ACTION CREATORS  **/
export const SET_TOS_SOCIAL_STATUS = 'SET_TOS_SOCIAL_STATUS';
export const setTosSocialStatus = (payload) => ({
    type: SET_TOS_SOCIAL_STATUS,
    payload,
});
export const SET_SHOW_TOS = 'SET_SHOW_TOS';
export const setShowToS = (show) => ({
    type: SET_SHOW_TOS,
    payload: show,
});
export const SET_TOS_SOCIAL_ACCEPTED = 'SET_TOS_SOCIAL_ACCEPTED';
export const setTosSocialAccepted = (payload) => ({
    type: SET_TOS_SOCIAL_ACCEPTED,
    payload,
});

export const acceptToS = ({
    onAccept,
    formName,
    actionName,
    trackLabel = null,
}) => (dispatch, getState) => {
    const state = getState();

    const sourceProvider = trackLabel
        ? trackLabel
        : getQuerySourceProvider({ state });
    trackToSAction({ state, sourceProvider, actionName });
    dispatch(clearAuthNotification());
    dispatch(setShowToS(false));
    const formData = getFormValues(formName)(state);
    dispatch(setTosSocialAccepted(true));
    onAccept(formData);
};

export const cancelToS = ({
    actionName,
    notificationMessage,
    trackLabel = null,
}) => (dispatch, getState) => {
    const state = getState();

    const sourceProvider = trackLabel
        ? trackLabel
        : getQuerySourceProvider({ state });

    trackToSAction({ state, sourceProvider, actionName });
    dispatch(
        showAuthNotification({
            message: notificationMessage,
        }),
    );
    dispatch(setShowToS(false));
    dispatch(cleanSocialAuthenticationData());
};

export const showToS = ({ actionName, trackLabel = null }) => (
    dispatch,
    getState,
) => {
    const state = getState();
    const sourceProvider = trackLabel
        ? trackLabel
        : getQuerySourceProvider({ state });

    dispatch(clearAuthNotification());
    dispatch(setShowToS(true));
    dispatch(setTosSocialAccepted(false));
    trackToSAction({ state, sourceProvider, actionName });
};
export const acceptSocialToS = () => (dispatch, getState) => {
    const state = getState();
    const {
        social: { socialData, socialProvider: sourceProvider },
        status: { tosSocialStatus },
    } = state;

    trackToSAction({
        state,
        sourceProvider,
        actionName: TOSMODAL_SOCIAL_ACCEPTED,
    });
    dispatch(clearAuthNotification());
    dispatch(setShowToS(false));
    dispatch(setTosSocialAccepted(true));
    if (sourceProvider === GA_APPLE) {
        if (tosSocialStatus === LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT) {
            handleAppleSocialLogin({
                data: socialData[sourceProvider],
                getState,
                dispatch,
                isSoftAccount: true,
            });
        }
    } else {
        dispatch(
            handleSocialLogin({
                data: socialData[sourceProvider],
            }),
        );
    }
};
